export default {"src":"https://images-cdn-staging.curipod.com/d-08de8ea7/_next/static/media/common_sense_media.9c180185.svg","height":123,"width":300};